import style from '../index.module.css'

import React from 'react'

import { Checkbox, Flex, Text } from 'components/ds'
import { TagDot } from 'components/search/search-columns/indicators-column/components/tag-dot'
import type { TagWithColor } from 'components/search/search-columns/indicators-column/utils/indicator-colors'
import HighlightedText from 'components/ui/highlighted-text'

type SelectedTagsProps<T> = {
  selectedTags: T[]
  // Reports the tag to deselect. The caller owns the selection, which matters
  // while a search is narrowing this list.
  onRemoveTag: (_tag: T) => void
  searchValue?: string
}

const SelectedTags = <T extends TagWithColor>({
  selectedTags,
  onRemoveTag,
  searchValue,
}: SelectedTagsProps<T>) => {
  if (!selectedTags?.length) return null
  return (
    <Flex direction="column" width="100%">
      {selectedTags.map(tag => (
        <Flex
          key={tag.id}
          direction="row"
          gap="2"
          className={style.Checkbox_RowContainer}
          asChild
        >
          <Text size="2" as="label">
            <Checkbox checked={true} onCheckedChange={() => onRemoveTag(tag)} />
            <TagDot tag={tag} />
            <HighlightedText
              text={tag.name}
              highlights={searchValue ? [searchValue] : []}
              customColors={{
                background: 'var(--disco-yellow)',
              }}
            />
          </Text>
        </Flex>
      ))}
    </Flex>
  )
}

export default SelectedTags
